import { lazy } from 'react';

const RegisterManufactureConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/manufacturer/register-manufacture',
			component: lazy(() => import('./RegisterManufactureContainer'))
		}
	]
};

export default RegisterManufactureConfig;
